import EditDiscountContainer from "./EditDiscountContainer";
export default EditDiscountContainer;
